<template>
  <div class="shop-table-inner">
    <el-table :data="tableData" stripe>
      <el-table-column label="收款码" width="160">
        <template slot-scope="scope">
          <div class="code-wrap">
            <el-button type="text" @click="codeView(scope.row)">
              {{
                scope.row.extNum == -1 ? "主机码" : "分机号" + scope.row.extNum
              }}
              <i class="el-icon-arrow-right el-icon--right"></i>
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="门店简称">
        <template slot-scope="scope">
          <span class="table_text">{{ scope.row.storeName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="所属部门/门店" width="180">
        <template slot-scope="scope">
          <span class="table_text">{{ scope.row.departmentName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="支持最低开票金额" width="135" align="right">
        <template slot-scope="scope">
          <span v-if="!scope.row.kpMoney">-</span>
          <span v-else style="margin-left: 10px">
            {{ scope.row.kpMoney | numberFormat }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="收款能力" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.status == '1'">已开启</span>
          <span v-else-if="scope.row.status == '0'">关闭</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" v-if="userAuth.extOperation">
        <template slot-scope="scope">
          <el-button
            @click="codeSet(scope.row)"
            type="text"
            v-if="treedata && treedata.length"
            >设置</el-button
          >
          <el-button
            @click="goDelete(scope.row.id)"
            v-if="scope.row.extNum !== -1"
            type="text"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { debounce } from "lodash";

export default {
  name: "ShopTable",
  props: {
    tableData: {
      type: Array
    },
    treedata: {
      type: Array
    },
    userAuth: {
      type: Object
    }
  },
  data() {
    return {
      deleteVisible: false // 删除popver控制
    };
  },
  methods: {
    codeView(row) {
      this.$emit("codeView", row);
    },
    codeSet({ id }) {
      this.$store.commit("setState", {
        shopDetailParams: id
      });
      this.$emit("codeSet", id);
    },
    goDelete: debounce(function(id) {
      this.deleteVisible = false;
      this.$emit("goDelete", id);
    }),
    urgePay(billNo) {
      this.$emit("goUrgePay", billNo);
    }
  },
  components: {}
};
</script>
<style lang="scss">
.info-delete-tips {
  width: 222px;
}
.shop-table-inner {
  .el-table {
    .cell {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      min-height: 21px;
      // max-height: 80px;
    }
  }
}
</style>
